
/* !!! This is code generated by Prisma. Do not edit directly. !!! */
/* eslint-disable */
// biome-ignore-all lint: generated file
// @ts-nocheck 
/*
* This file exports all enum related types from the schema.
*
* 🟢 You can import this file directly.
*/

export const profile_type = {
  Society_User: 'Society_User',
  Institution: 'Institution'
} as const

export type profile_type = (typeof profile_type)[keyof typeof profile_type]


export const invoice_status = {
  OPEN: 'OPEN',
  PAID: 'PAID',
  CANCELED: 'CANCELED',
  PARTIAL_PAID: 'PARTIAL_PAID',
  ON_HOLD: 'ON_HOLD'
} as const

export type invoice_status = (typeof invoice_status)[keyof typeof invoice_status]


export const society_setting_type = {
  STRING: 'STRING',
  STRING_ARRAY: 'STRING_ARRAY',
  OBJECT: 'OBJECT',
  HTML: 'HTML',
  NUMBER: 'NUMBER',
  BOOLEAN: 'BOOLEAN',
  EMAIL_TEMPLATE_ID: 'EMAIL_TEMPLATE_ID'
} as const

export type society_setting_type = (typeof society_setting_type)[keyof typeof society_setting_type]


export const dynamic_tag_type = {
  ProfileTag: 'ProfileTag',
  GroupTag: 'GroupTag',
  DynamicMembership: 'DynamicMembership',
  DynamicGroup: 'DynamicGroup',
  DynamicCertificationInstance: 'DynamicCertificationInstance',
  DynamicEducationInstance: 'DynamicEducationInstance',
  DynamicInvoiceItem: 'DynamicInvoiceItem'
} as const

export type dynamic_tag_type = (typeof dynamic_tag_type)[keyof typeof dynamic_tag_type]


export const activity_sheet_category = {
  GROUP: 'GROUP',
  SUBMISSION: 'SUBMISSION',
  ATTENDANCE: 'ATTENDANCE',
  MENTORSHIP: 'MENTORSHIP',
  OTHER: 'OTHER'
} as const

export type activity_sheet_category = (typeof activity_sheet_category)[keyof typeof activity_sheet_category]


export const app_platform_type = {
  android: 'android',
  ios: 'ios'
} as const

export type app_platform_type = (typeof app_platform_type)[keyof typeof app_platform_type]


export const app_route_config_nav = {
  userhub_nav: 'userhub_nav',
  app_nav: 'app_nav',
  admin_nav: 'admin_nav',
  userhub_parent_child_tab: 'userhub_parent_child_tab'
} as const

export type app_route_config_nav = (typeof app_route_config_nav)[keyof typeof app_route_config_nav]


export const attendee_registration_status = {
  REGISTERED: 'REGISTERED',
  INTENDS_TO_REGISTER: 'INTENDS_TO_REGISTER',
  UNPAID: 'UNPAID',
  CANCELED: 'CANCELED',
  NOT_STARTED: 'NOT_STARTED',
  INCOMPLETE: 'INCOMPLETE'
} as const

export type attendee_registration_status = (typeof attendee_registration_status)[keyof typeof attendee_registration_status]


export const conference_event_template_type = {
  schedule_main_template: 'schedule_main_template',
  schedule_sub_template: 'schedule_sub_template',
  header_main_template: 'header_main_template',
  header_sub_template: 'header_sub_template',
  body_template: 'body_template',
  banner_template: 'banner_template'
} as const

export type conference_event_template_type = (typeof conference_event_template_type)[keyof typeof conference_event_template_type]


export const conference_poster_gallery_view_count_config = {
  none: 'none',
  presenters: 'presenters',
  all: 'all'
} as const

export type conference_poster_gallery_view_count_config = (typeof conference_poster_gallery_view_count_config)[keyof typeof conference_poster_gallery_view_count_config]


export const conference_submission_status = {
  Pending_: 'Pending_',
  Accepted_: 'Accepted_',
  Rejected_: 'Rejected_'
} as const

export type conference_submission_status = (typeof conference_submission_status)[keyof typeof conference_submission_status]


export const conference_submission_type = {
  Poster: 'Poster',
  Symposium: 'Symposium',
  Registration: 'Registration'
} as const

export type conference_submission_type = (typeof conference_submission_type)[keyof typeof conference_submission_type]


export const content_type = {
  html: 'html',
  reg_type: 'reg_type',
  carousel: 'carousel',
  product_grid: 'product_grid',
  product_page: 'product_page',
  file: 'file',
  checkout_optional_products: 'checkout_optional_products'
} as const

export type content_type = (typeof content_type)[keyof typeof content_type]


export const dashboard_module_type = {
  sum: 'sum',
  total: 'total',
  stackedBarChart: 'stackedBarChart',
  lineChart: 'lineChart',
  shortTable: 'shortTable',
  ringGraph: 'ringGraph'
} as const

export type dashboard_module_type = (typeof dashboard_module_type)[keyof typeof dashboard_module_type]


export const discount_type = {
  USD: 'USD',
  PERCENT: 'PERCENT'
} as const

export type discount_type = (typeof discount_type)[keyof typeof discount_type]


export const discussion_forum_type = {
  QA: 'QA',
  billboard: 'billboard',
  group: 'group'
} as const

export type discussion_forum_type = (typeof discussion_forum_type)[keyof typeof discussion_forum_type]


export const email_priority = {
  Low: 'Low',
  Normal: 'Normal',
  High: 'High'
} as const

export type email_priority = (typeof email_priority)[keyof typeof email_priority]


export const event_category_type = {
  Speaking: 'Speaking',
  Other: 'Other'
} as const

export type event_category_type = (typeof event_category_type)[keyof typeof event_category_type]


export const event_format_type = {
  In_Person: 'In_Person',
  Virtual: 'Virtual',
  Hybrid: 'Hybrid'
} as const

export type event_format_type = (typeof event_format_type)[keyof typeof event_format_type]


export const form_category = {
  Conference_Submission: 'Conference_Submission',
  Travel_Award: 'Travel_Award',
  Conference_Registration: 'Conference_Registration',
  Profile: 'Profile',
  Scorecard: 'Scorecard',
  Disclosure: 'Disclosure',
  Other: 'Other',
  Institution_Membership: 'Institution_Membership',
  Mentor_Form: 'Mentor_Form',
  Mentee_Form: 'Mentee_Form',
  Quiz_Builder: 'Quiz_Builder',
  Generated_Quiz: 'Generated_Quiz',
  Grouped_Conference_Registration: 'Grouped_Conference_Registration'
} as const

export type form_category = (typeof form_category)[keyof typeof form_category]


export const group_meeting_recurring = {
  none: 'none',
  daily: 'daily',
  weekly: 'weekly',
  monthly: 'monthly',
  yearly: 'yearly'
} as const

export type group_meeting_recurring = (typeof group_meeting_recurring)[keyof typeof group_meeting_recurring]


export const identity_provider_type = {
  COGNITO: 'COGNITO',
  GOOGLE: 'GOOGLE',
  FACEBOOK: 'FACEBOOK',
  APPLE: 'APPLE',
  MICROSOFT: 'MICROSOFT'
} as const

export type identity_provider_type = (typeof identity_provider_type)[keyof typeof identity_provider_type]


export const invoiceitem_status = {
  OPEN: 'OPEN',
  PAID: 'PAID',
  REFUNDED: 'REFUNDED',
  CANCELED: 'CANCELED'
} as const

export type invoiceitem_status = (typeof invoiceitem_status)[keyof typeof invoiceitem_status]


export const message_type = {
  Notification: 'Notification',
  Other: 'Other'
} as const

export type message_type = (typeof message_type)[keyof typeof message_type]


export const notification_category = {
  Group: 'Group',
  Speaker: 'Speaker',
  Tag: 'Tag',
  MembershipCategory: 'MembershipCategory',
  Individual: 'Individual'
} as const

export type notification_category = (typeof notification_category)[keyof typeof notification_category]


export const payment_method = {
  AUTHORIZE_NET: 'AUTHORIZE_NET',
  CHECK: 'CHECK',
  WIRETRANSFER: 'WIRETRANSFER',
  ECH: 'ECH',
  CASH: 'CASH',
  OTHER: 'OTHER'
} as const

export type payment_method = (typeof payment_method)[keyof typeof payment_method]


export const payment_status = {
  CAPTURED: 'CAPTURED',
  SETTLED: 'SETTLED',
  VOID: 'VOID',
  DECLINED: 'DECLINED',
  AUTHORIZED: 'AUTHORIZED',
  REFUND: 'REFUND',
  REFUND_PENDING_SETTLEMENT: 'REFUND_PENDING_SETTLEMENT'
} as const

export type payment_status = (typeof payment_status)[keyof typeof payment_status]


export const product_duration_type = {
  NONE: 'NONE',
  RANGE: 'RANGE',
  LENGTH: 'LENGTH'
} as const

export type product_duration_type = (typeof product_duration_type)[keyof typeof product_duration_type]


export const product_length_increment = {
  MONTH: 'MONTH'
} as const

export type product_length_increment = (typeof product_length_increment)[keyof typeof product_length_increment]


export const review_session_role = {
  DecisionMaker: 'DecisionMaker'
} as const

export type review_session_role = (typeof review_session_role)[keyof typeof review_session_role]


export const room_layout = {
  banquet: 'banquet',
  conference: 'conference',
  square: 'square',
  reception: 'reception',
  school: 'school',
  theater: 'theater',
  ushape: 'ushape',
  other: 'other'
} as const

export type room_layout = (typeof room_layout)[keyof typeof room_layout]


export const room_neighbor_connection = {
  airwall: 'airwall',
  hallway: 'hallway',
  door: 'door',
  wall: 'wall',
  other: 'other'
} as const

export type room_neighbor_connection = (typeof room_neighbor_connection)[keyof typeof room_neighbor_connection]


export const sentiment_type = {
  like: 'like',
  dislike: 'dislike'
} as const

export type sentiment_type = (typeof sentiment_type)[keyof typeof sentiment_type]


export const submission_assignment_type = {
  Multiparticipant: 'Multiparticipant',
  Education: 'Education',
  PostConference: 'PostConference',
  Survey: 'Survey',
  ConferenceRegistration: 'ConferenceRegistration'
} as const

export type submission_assignment_type = (typeof submission_assignment_type)[keyof typeof submission_assignment_type]


export const submission_instance_reviewer_status = {
  New: 'New',
  In_Progress: 'In_Progress',
  Recused: 'Recused',
  Removed: 'Removed',
  Completed: 'Completed'
} as const

export type submission_instance_reviewer_status = (typeof submission_instance_reviewer_status)[keyof typeof submission_instance_reviewer_status]


export const submission_process_step_type = {
  Review: 'Review',
  Decision: 'Decision',
  Final_Decision: 'Final_Decision'
} as const

export type submission_process_step_type = (typeof submission_process_step_type)[keyof typeof submission_process_step_type]


export const submission_workflow_setting_name = {
  create_requires_profile_update: 'create_requires_profile_update',
  start_requires_profile_update: 'start_requires_profile_update'
} as const

export type submission_workflow_setting_name = (typeof submission_workflow_setting_name)[keyof typeof submission_workflow_setting_name]


export const submission_workflow_type = {
  Membership: 'Membership',
  Submission: 'Submission',
  Simple: 'Simple',
  Registration: 'Registration',
  Conference: 'Conference',
  Group: 'Group'
} as const

export type submission_workflow_type = (typeof submission_workflow_type)[keyof typeof submission_workflow_type]


export const submissionresponsetype = {
  Initiate: 'Initiate',
  ScoreCard: 'ScoreCard',
  Approval: 'Approval',
  Other: 'Other',
  Cosubmitter: 'Cosubmitter',
  ConsolidatedMultiParticipant: 'ConsolidatedMultiParticipant',
  Quiz: 'Quiz',
  Disclosure: 'Disclosure'
} as const

export type submissionresponsetype = (typeof submissionresponsetype)[keyof typeof submissionresponsetype]


export const tm_subtask_status = {
  Flagged: 'Flagged',
  On_hold: 'On_hold',
  Closed: 'Closed',
  Complete: 'Complete'
} as const

export type tm_subtask_status = (typeof tm_subtask_status)[keyof typeof tm_subtask_status]


export const tm_task_priority = {
  Urgent: 'Urgent',
  High: 'High',
  Medium: 'Medium',
  Low: 'Low'
} as const

export type tm_task_priority = (typeof tm_task_priority)[keyof typeof tm_task_priority]


export const workflow_group_type = {
  Volunteer: 'Volunteer',
  Enroll: 'Enroll',
  Role: 'Role'
} as const

export type workflow_group_type = (typeof workflow_group_type)[keyof typeof workflow_group_type]


export const workflow_type = {
  Membership: 'Membership',
  Fulfillment: 'Fulfillment',
  Submission: 'Submission',
  Other: 'Other'
} as const

export type workflow_type = (typeof workflow_type)[keyof typeof workflow_type]


export const notification_event_type = {
  push_notification: 'push_notification',
  message_notification: 'message_notification'
} as const

export type notification_event_type = (typeof notification_event_type)[keyof typeof notification_event_type]


export const notification_status = {
  pending: 'pending',
  sent: 'sent',
  unread: 'unread',
  read: 'read',
  error: 'error'
} as const

export type notification_status = (typeof notification_status)[keyof typeof notification_status]
